import { ReactNode } from 'react';

import { ColumnDef, ColumnFiltersState, SortingState } from '@tanstack/react-table';

import { TablePageTable } from '@/components/table-page/table-page-table';
import { cn } from '@/lib/utils';

interface DrawerTableProps<T> {
  data: T[];
  columns: ColumnDef<T>[];
  onRowClick?: (row: T, event: React.MouseEvent<HTMLTableRowElement>) => void;
  onSortingChange?: (sorting: { key?: string; direction?: 'asc' | 'desc' }) => void;
  sorting?: SortingState;
  columnFilters?: ColumnFiltersState;
  onColumnFiltersChange?: (state: ColumnFiltersState) => void;
  notFoundDisplay?: ReactNode;
  tableClassName?: string;
  cellClassName?: string;
  headClassName?: string;
  headerClassName?: string;
  containerClassName?: string;
}

export function DrawerTable<T>({
  data,
  columns,
  onRowClick,
  onSortingChange,
  sorting,
  columnFilters,
  onColumnFiltersChange,
  notFoundDisplay,
  tableClassName,
  cellClassName,
  headClassName,
  headerClassName,
  containerClassName,
}: DrawerTableProps<T>) {
  return (
    <TablePageTable
      data={data}
      columns={columns}
      onRowClick={onRowClick}
      onSortingChange={onSortingChange}
      sorting={sorting}
      columnFilters={columnFilters}
      onColumnFiltersChange={onColumnFiltersChange}
      notFoundDisplay={notFoundDisplay}
      tableClassName={cn('table-fixed [&_tr:last-child_td]:border-b-0', tableClassName)}
      cellClassName={cn('border-x-transparent', cellClassName)}
      headClassName={cn('!border-none', headClassName)}
      headerClassName={cn('after:!hidden before:!hidden', headerClassName)}
      containerClassName={containerClassName}
    />
  );
}
